import { render, staticRenderFns } from "./AddNewDialog.vue?vue&type=template&id=16a37c82&scoped=true"
import script from "./AddNewDialog.vue?vue&type=script&lang=js"
export * from "./AddNewDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewDialog.vue?vue&type=style&index=0&id=16a37c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a37c82",
  null
  
)

export default component.exports